import { render, staticRenderFns } from "./TrayVariants.vue?vue&type=template&id=1974573c"
import script from "./TrayVariants.vue?vue&type=script&lang=js"
export * from "./TrayVariants.vue?vue&type=script&lang=js"
import style0 from "./TrayVariants.vue?vue&type=style&index=0&id=1974573c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports